import { useCollection } from "@/api/hooks";
import { useSetCollectionFitRangeMutation } from "@/api/api";
import { Switch } from "../switch";
import { Field, FieldContent, FieldDescription, FieldLabel } from "../field";

export default function CollectionFitRangeToggle() {
  const collection = useCollection();
  const [setFitRange] = useSetCollectionFitRangeMutation();

  // A provider collection has no time range of its own: its records are
  // fetched live for whatever range is already on screen. The server refuses
  // the setting too.
  if (!collection || collection.provider_key) return null;

  const handleToggle = (fitRangeOnOpen: boolean) => {
    setFitRange({ collectionID: collection.id, fitRangeOnOpen });
  };

  return (
    <div className="rounded-[10px] bg-secondary border border-border px-4 py-3">
      <Field orientation="horizontal">
        <FieldContent>
          <FieldLabel
            htmlFor="collectionFitRange"
            className="text-[13.5px] font-semibold"
          >
            Open on its own time range
          </FieldLabel>
          <FieldDescription className="text-[12px]">
            Opening this collection moves the time range to fit its records,
            instead of keeping the one already on screen
          </FieldDescription>
        </FieldContent>
        <Switch
          id="collectionFitRange"
          checked={!!collection.fit_range_on_open}
          onCheckedChange={handleToggle}
        />
      </Field>
    </div>
  );
}
